import OnestockOnboardingNotCompletedContainer from "./OnestockOnboardingNotCompletedContainer";
import OnestockOnboardingNotCompletedStore from "./OnestockOnboardingNotCompletedStore";

export default OnestockOnboardingNotCompletedStore(OnestockOnboardingNotCompletedContainer);